import {BaseTerms} from "../../infrastructure/models/base-terms";

export class ScoresBarWidgetTerms extends BaseTerms {}